const lcmsJcamp = `
##TITLE=Spectrum
##JCAMP-DX=5.00 $$ chemotion-converter-app (1.8.0)
##DATA TYPE=MASS SPECTRUM
##DATA CLASS=NTUPLES
##ORIGIN=
##OWNER=
##XUNITS=m/z
##YUNITS=Intensity
##SOFTWARE=openlab
##SCAN_MODE=negativ
##TYPE=ms spectrum
##NTUPLES=MULTIDIMENSIONAL
##VAR_NAME=T, m/z, Intensity
##SYMBOL=T, X, Y
##VAR_TYPE=PAGE, X, Y
##VAR_DIM=1200, 572, 572
##UNITS=, m/z, Intensity
##PAGE=T= 0.009
##XYDATA=(XY..XY)
100.5999984741211, 31.25
101.30000305175781, 42.5
101.80000305175781, 25.0
102.0, 25.0
102.80000305175781, 18.75
104.30000305175781, 4.375
105.19999694824219, 21.875
105.9000015258789, 13.75
107.0999984741211, 36.25
108.0, 10.0
108.80000305175781, 10.0
112.30000305175781, 60.0
113.80000305175781, 13.125
114.9000015258789, 19.375
116.9000015258789, 3.75
117.69999694824219, 26.25
118.9000015258789, 35.625
119.5, 15.625
120.30000305175781, 18.75
121.0999984741211, 31.25
122.0999984741211, 17.5
123.5999984741211, 14.375
124.69999694824219, 36.875
125.80000305175781, 34.375
126.69999694824219, 26.875
127.19999694824219, 15.0
127.80000305175781, 15.0
129.3000030517578, 0.0
129.89999389648438, 9.375
130.39999389648438, 15.625
131.6999969482422, 51.25
132.8000030517578, 30.625
133.3000030517578, 27.5
135.1999969482422, 3.75
136.1999969482422, 8.75
137.1999969482422, 46.25
138.0, 51.25
139.3000030517578, 23.125
142.3000030517578, 41.25
143.1999969482422, 10.625
144.10000610351562, 40.0
145.6999969482422, 23.75
146.6999969482422, 9.375
148.5, 1.25
149.8000030517578, 45.625
150.3000030517578, 50.0
151.10000610351562, 36.875
152.10000610351562, 35.625
152.6999969482422, 7.5
153.8000030517578, 9.375
155.10000610351562, 11.25
156.0, 29.375
156.6999969482422, 13.75
157.5, 26.25
158.10000610351562, 26.25
160.8000030517578, 5.625
162.10000610351562, 39.375
163.0, 41.875
163.39999389648438, 38.125
164.39999389648438, 33.125
165.10000610351562, 19.375
165.6999969482422, 8.125
166.6999969482422, 4.375
167.60000610351562, 23.75
168.1999969482422, 29.375
168.8000030517578, 8.75
169.5, 1.25
171.6999969482422, 39.375
173.10000610351562, 8.75
173.5, 13.125
174.3000030517578, 24.375
175.0, 31.25
175.89999389648438, 48.125
176.39999389648438, 36.875
178.3000030517578, 5.0
178.8000030517578, 5.625
179.6999969482422, 23.125
180.6999969482422, 8.75
181.89999389648438, 43.125
183.10000610351562, 30.0
183.8000030517578, 21.25
184.39999389648438, 1.25
185.89999389648438, 14.375
186.5, 15.625
187.1999969482422, 38.75
187.89999389648438, 55.0
188.8000030517578, 28.125
189.5, 28.75
192.5, 16.875
193.10000610351562, 14.375
193.8000030517578, 31.875
194.3000030517578, 41.875
195.6999969482422, 6.875
196.39999389648438, 29.375
197.5, 1.25
198.39999389648438, 18.125
199.1999969482422, 47.5
200.1999969482422, 39.375
201.0, 50.0
201.60000610351562, 36.25
204.1999969482422, 4.375
204.5, 5.0
206.0, 49.375
206.60000610351562, 43.75
207.6999969482422, 35.0
208.1999969482422, 20.0
208.8000030517578, 9.375
209.8000030517578, 3.75
212.1999969482422, 36.25
213.0, 20.625
213.8000030517578, 40.0
214.60000610351562, 26.875
215.0, 21.875
217.6999969482422, 12.5
219.3000030517578, 50.0
219.8000030517578, 47.5
221.3000030517578, 8.75
224.0, 20.0
224.8000030517578, 33.125
225.8000030517578, 31.875
226.6999969482422, 31.875
230.0, 20.0
231.0, 63.125
232.5, 36.875
233.3000030517578, 2.5
235.6999969482422, 0.625
236.10000610351562, 10.625
236.89999389648438, 16.875
237.5, 23.75
238.3000030517578, 40.0
238.8000030517578, 58.125
239.6999969482422, 43.75
240.3000030517578, 10.625
241.3000030517578, 1.875
243.1999969482422, 38.125
244.1999969482422, 43.75
244.89999389648438, 50.0
245.1999969482422, 49.375
249.10000610351562, 19.375
249.8000030517578, 21.875
250.8000030517578, 48.125
251.6999969482422, 22.5
253.1999969482422, 15.625
254.5, 10.0
255.10000610351562, 33.75
255.60000610351562, 18.75
256.20001220703125, 23.75
257.1000061035156, 8.125
257.6000061035156, 10.625
258.20001220703125, 13.125
261.1000061035156, 63.75
262.20001220703125, 16.25
262.70001220703125, 31.25
263.3999938964844, 41.25
264.70001220703125, 29.375
267.8999938964844, 23.75
268.79998779296875, 34.375
269.70001220703125, 27.5
270.5, 3.125
271.20001220703125, 20.0
271.70001220703125, 6.875
271.8999938964844, 6.875
273.79998779296875, 30.625
274.20001220703125, 36.875
274.6000061035156, 33.125
275.79998779296875, 33.75
276.8999938964844, 16.875
280.0, 25.0
280.79998779296875, 49.375
281.3999938964844, 23.125
281.79998779296875, 35.0
282.29998779296875, 23.75
283.1000061035156, 15.625
284.8999938964844, 2.5
285.79998779296875, 8.125
286.70001220703125, 21.875
287.20001220703125, 16.25
288.0, 18.75
288.70001220703125, 10.0
289.70001220703125, 10.625
290.5, 25.0
292.8999938964844, 37.5
294.1000061035156, 28.75
294.70001220703125, 45.0
295.5, 50.0
298.1000061035156, 23.75
298.6000061035156, 5.625
299.3999938964844, 41.25
299.79998779296875, 45.0
300.1000061035156, 45.0
301.1000061035156, 23.75
302.0, 26.25
304.3999938964844, 7.5
305.20001220703125, 39.375
306.3999938964844, 54.375
307.0, 23.125
308.0, 16.25
308.8999938964844, 1.25
311.79998779296875, 59.375
312.79998779296875, 45.625
313.79998779296875, 24.375
314.5, 12.5
316.0, 4.375
317.29998779296875, 40.625
317.8999938964844, 66.875
318.79998779296875, 18.125
320.1000061035156, 29.375
320.70001220703125, 0.625
323.20001220703125, 4.375
323.6000061035156, 29.375
324.6000061035156, 41.25
324.8999938964844, 38.75
326.0, 22.5
326.3999938964844, 22.5
327.20001220703125, 18.75
329.3999938964844, 13.125
330.5, 42.5
331.1000061035156, 37.5
332.1000061035156, 35.625
332.79998779296875, 2.5
335.70001220703125, 17.5
336.5, 27.5
337.5, 36.875
338.20001220703125, 32.5
339.8999938964844, 0.0
342.3999938964844, 28.75
343.5, 31.25
344.1000061035156, 34.375
344.79998779296875, 21.25
347.29998779296875, 1.875
348.29998779296875, 8.75
349.8999938964844, 59.375
350.5, 37.5
351.6000061035156, 29.375
352.3999938964844, 30.0
354.20001220703125, 12.5
354.70001220703125, 3.75
355.6000061035156, 46.25
356.20001220703125, 28.75
356.79998779296875, 50.625
357.3999938964844, 42.5
357.8999938964844, 25.625
358.6000061035156, 1.25
361.0, 36.25
361.79998779296875, 38.125
362.5, 44.375
363.8999938964844, 26.25
366.1000061035156, 14.375
367.1000061035156, 26.875
368.1000061035156, 52.5
369.70001220703125, 21.875
370.5, 15.625
372.5, 11.25
373.20001220703125, 9.375
374.1000061035156, 35.625
374.8999938964844, 11.875
375.5, 23.125
375.8999938964844, 30.625
376.5, 15.625
377.20001220703125, 19.375
378.29998779296875, 28.75
379.5, 23.125
380.29998779296875, 20.625
380.6000061035156, 20.0
381.3999938964844, 41.875
382.5, 33.75
383.6000061035156, 12.5
385.79998779296875, 10.0
386.20001220703125, 7.5
386.8999938964844, 23.75
387.29998779296875, 25.625
388.1000061035156, 48.125
388.8999938964844, 19.375
391.79998779296875, 23.75
392.70001220703125, 51.25
393.5, 26.25
394.0, 33.125
394.70001220703125, 13.125
396.0, 1.25
397.20001220703125, 10.0
397.79998779296875, 13.125
399.0, 15.0
399.79998779296875, 30.0
400.6000061035156, 20.625
401.1000061035156, 18.75
401.79998779296875, 9.375
403.20001220703125, 34.375
405.5, 15.0
406.20001220703125, 42.5
406.8999938964844, 28.125
408.79998779296875, 18.75
409.20001220703125, 11.25
410.8999938964844, 24.375
411.5, 18.75
412.1000061035156, 25.625
412.70001220703125, 34.375
413.20001220703125, 35.625
414.3999938964844, 27.5
415.1000061035156, 5.0
416.79998779296875, 2.5
417.29998779296875, 37.5
418.1000061035156, 35.0
419.1000061035156, 11.25
419.6000061035156, 10.0
421.1000061035156, 30.625
422.5, 4.375
423.20001220703125, 5.0
423.8999938964844, 12.5
424.6000061035156, 21.875
425.20001220703125, 54.375
426.1000061035156, 22.5
426.6000061035156, 25.625
427.20001220703125, 9.375
428.0, 6.875
428.6000061035156, 30.0
429.79998779296875, 8.125
430.5, 43.125
431.20001220703125, 16.25
431.8999938964844, 21.25
433.29998779296875, 27.5
433.8999938964844, 11.875
434.8999938964844, 2.5
435.6000061035156, 29.375
436.1000061035156, 8.125
436.70001220703125, 43.75
437.70001220703125, 40.625
438.3999938964844, 32.5
439.20001220703125, 51.25
441.6000061035156, 0.625
442.20001220703125, 14.375
443.1000061035156, 33.125
443.5, 26.25
444.3999938964844, 20.0
445.20001220703125, 26.25
445.79998779296875, 28.125
447.70001220703125, 10.0
448.1000061035156, 14.375
448.6000061035156, 24.375
449.3999938964844, 34.375
450.29998779296875, 23.75
451.0, 10.0
451.70001220703125, 6.875
454.1000061035156, 5.625
455.0, 26.25
455.70001220703125, 53.75
456.6000061035156, 27.5
457.5, 31.875
458.0, 1.875
459.29998779296875, 5.0
460.1000061035156, 37.5
461.20001220703125, 8.75
462.29998779296875, 31.25
463.0, 23.75
464.0, 9.375
465.3999938964844, 18.75
467.6000061035156, 23.125
468.6000061035156, 53.75
469.8999938964844, 24.375
470.5, 28.125
471.3999938964844, 11.875
472.20001220703125, 10.625
473.6000061035156, 8.125
474.3999938964844, 32.5
475.5, 30.0
476.3999938964844, 19.375
477.29998779296875, 46.25
479.1000061035156, 23.75
480.29998779296875, 21.25
480.8999938964844, 36.25
481.5, 46.25
482.0, 40.625
483.1000061035156, 22.5
484.1000061035156, 15.0
485.20001220703125, 0.625
485.70001220703125, 6.875
486.70001220703125, 47.5
488.0, 30.0
488.70001220703125, 25.0
489.6000061035156, 22.5
490.5, 19.375
491.3999938964844, 5.0
492.3999938964844, 28.125
493.6000061035156, 43.75
494.79998779296875, 33.75
495.8999938964844, 23.125
496.3999938964844, 14.375
498.79998779296875, 36.25
499.79998779296875, 26.875
500.29998779296875, 43.125
501.0, 40.0
502.0, 25.0
504.70001220703125, 18.125
505.6000061035156, 41.25
506.3999938964844, 40.0
508.20001220703125, 4.375
510.79998779296875, 27.5
512.2000122070312, 72.5
513.0999755859375, 23.125
513.4000244140625, 23.125
514.2000122070312, 18.75
515.9000244140625, 22.5
518.0, 24.375
518.5, 9.375
519.5, 23.75
520.4000244140625, 23.125
521.0, 11.875
522.9000244140625, 33.75
524.2999877929688, 36.25
525.5999755859375, 26.25
526.7999877929688, 2.5
528.2999877929688, 1.875
530.0999755859375, 19.375
530.9000244140625, 58.125
531.7999877929688, 31.875
532.5, 32.5
533.4000244140625, 24.375
534.4000244140625, 0.625
534.7999877929688, 4.375
535.9000244140625, 29.375
537.4000244140625, 48.125
538.0, 43.75
538.7999877929688, 21.25
542.0, 25.625
542.9000244140625, 38.75
543.9000244140625, 45.625
544.7999877929688, 14.375
545.7000122070312, 25.625
546.5999755859375, 9.375
549.0999755859375, 48.75
549.9000244140625, 13.75
550.5999755859375, 8.75
551.4000244140625, 23.125
552.7000122070312, 1.875
554.0, 36.25
555.0999755859375, 38.75
555.7000122070312, 55.0
556.4000244140625, 58.125
557.4000244140625, 53.75
560.4000244140625, 11.25
561.2000122070312, 20.625
561.7000122070312, 19.375
562.4000244140625, 33.75
563.0999755859375, 31.25
564.7999877929688, 1.875
566.2999877929688, 6.25
567.2999877929688, 35.625
567.9000244140625, 50.625
568.5, 46.875
569.9000244140625, 12.5
570.5, 22.5
573.0999755859375, 4.375
573.7000122070312, 11.25
574.4000244140625, 23.125
575.7000122070312, 22.5
576.4000244140625, 21.25
577.2000122070312, 23.125
578.2000122070312, 0.625
579.2999877929688, 6.875
579.7000122070312, 5.625
580.4000244140625, 35.0
580.9000244140625, 25.0
581.5999755859375, 33.125
583.2000122070312, 22.5
585.2000122070312, 1.875
587.5, 68.75
588.9000244140625, 21.25
590.7999877929688, 20.0
592.2999877929688, 21.875
593.5, 51.875
594.5999755859375, 34.375
595.2999877929688, 50.0
597.2000122070312, 0.625
598.5, 42.5
599.5, 45.625
600.4000244140625, 30.0
601.0999755859375, 22.5
601.5999755859375, 15.0
603.9000244140625, 4.375
604.7000122070312, 6.875
605.5999755859375, 25.0
606.5999755859375, 19.375
607.0, 24.375
607.5, 19.375
608.0999755859375, 32.5
610.2999877929688, 3.125
611.0999755859375, 46.25
612.2000122070312, 56.25
613.4000244140625, 38.75
614.7999877929688, 10.0
615.5, 2.5
617.5, 46.25
618.0, 28.125
618.7999877929688, 19.375
620.2000122070312, 38.125
622.2999877929688, 5.625
623.0, 10.625
623.5999755859375, 38.125
624.0999755859375, 40.625
625.2000122070312, 46.875
626.0, 10.625
627.2000122070312, 5.0
628.5999755859375, 24.375
629.5999755859375, 58.75
630.7000122070312, 56.25
631.5, 31.875
631.9000244140625, 27.5
632.5, 11.25
633.0, 24.375
634.2000122070312, 18.125
636.2999877929688, 15.0
637.2999877929688, 27.5
639.0, 8.75
641.4000244140625, 21.25
642.5, 40.0
643.5999755859375, 36.875
645.0, 8.75
646.2000122070312, 10.0
647.0999755859375, 16.25
648.4000244140625, 7.5
649.2999877929688, 23.125
649.7000122070312, 24.375
650.2000122070312, 37.5
651.0999755859375, 17.5
652.5999755859375, 16.875
654.2000122070312, 57.5
655.4000244140625, 36.25
655.9000244140625, 41.25
656.4000244140625, 34.375
657.0, 10.0
657.5999755859375, 18.75
658.5999755859375, 4.375
659.7999877929688, 2.5
661.5, 28.75
662.5999755859375, 27.5
663.2000122070312, 25.625
664.0999755859375, 35.0
665.4000244140625, 21.25
666.0, 18.125
667.2000122070312, 29.375
668.0999755859375, 40.0
669.0, 12.5
669.5, 8.75
669.9000244140625, 3.125
672.7000122070312, 8.75
674.2000122070312, 56.875
674.7999877929688, 58.75
675.9000244140625, 53.125
676.5, 50.625
678.7000122070312, 20.0
679.5999755859375, 45.0
680.2000122070312, 15.625
680.9000244140625, 23.125
682.0999755859375, 6.875
684.7999877929688, 8.125
685.5, 28.75
686.4000244140625, 58.75
687.2000122070312, 39.375
687.5999755859375, 40.625
688.5999755859375, 4.375
689.4000244140625, 7.5
690.0999755859375, 3.125
691.7999877929688, 5.625
692.0999755859375, 6.875
692.7999877929688, 8.125
693.0999755859375, 11.25
694.0999755859375, 23.75
695.7000122070312, 12.5
696.7000122070312, 25.625
698.0999755859375, 32.5
699.0, 64.375
700.2000122070312, 28.75
700.9000244140625, 43.125
701.7000122070312, 4.375
706.2999877929688, 49.375
707.0999755859375, 15.625
708.0, 21.25
708.9000244140625, 13.125
710.0, 23.125
710.9000244140625, 43.75
711.9000244140625, 34.375
712.7000122070312, 18.125
713.4000244140625, 4.375
714.0, 19.375
716.2999877929688, 14.375
717.5999755859375, 45.625
718.7999877929688, 60.0
719.2999877929688, 31.25
720.2999877929688, 42.5
721.0999755859375, 13.75
721.9000244140625, 2.5
722.7000122070312, 26.25
724.0, 30.625
725.4000244140625, 12.5
727.4000244140625, 26.25
728.7999877929688, 22.5
730.4000244140625, 41.875
731.5999755859375, 48.125
732.5, 42.5
733.0, 18.75
734.2999877929688, 3.75
736.0999755859375, 45.0
736.9000244140625, 13.75
737.7000122070312, 16.875
738.9000244140625, 3.75
739.5, 0.625
740.7999877929688, 23.125
741.5999755859375, 40.625
742.5999755859375, 60.0
743.4000244140625, 70.625
744.7000122070312, 9.375
745.2000122070312, 18.75
745.7000122070312, 13.75
748.7999877929688, 21.875
749.2000122070312, 27.5
750.9000244140625, 41.25
751.5, 36.25
752.2999877929688, 32.5
754.2000122070312, 15.625
755.5999755859375, 38.75
756.4000244140625, 12.5
757.5999755859375, 11.25
760.7000122070312, 16.25
761.4000244140625, 50.0
762.2999877929688, 51.25
763.2000122070312, 43.75
764.0, 19.375
764.5, 3.75
766.2000122070312, 10.0
767.2999877929688, 21.25
768.2999877929688, 23.125
769.5999755859375, 5.0
770.5999755859375, 0.625
773.5, 75.0
774.5, 46.875
774.9000244140625, 46.875
776.7999877929688, 28.75
778.4000244140625, 6.875
779.5999755859375, 6.875
780.5, 4.375
781.2000122070312, 11.875
782.2000122070312, 25.0
783.0, 46.25
784.5, 29.375
785.5999755859375, 45.0
786.7999877929688, 57.5
788.0999755859375, 41.25
791.5, 10.0
792.2000122070312, 18.75
793.0, 36.25
793.7000122070312, 30.625
795.0999755859375, 45.0
796.2999877929688, 14.375
797.2999877929688, 4.375
798.0999755859375, 37.5
798.7999877929688, 44.375
799.9000244140625, 5.625
804.0999755859375, 31.875
805.0, 43.75
805.7999877929688, 34.375
806.2999877929688, 36.25
807.0, 36.25
808.2000122070312, 36.875
809.2999877929688, 10.625
810.0, 14.375
811.5, 2.5
812.5, 9.375
815.7000122070312, 31.875
817.2000122070312, 46.875
818.2000122070312, 66.875
819.5, 23.125
820.4000244140625, 28.75
824.4000244140625, 1.25
825.0999755859375, 47.5
826.2999877929688, 8.125
827.0, 35.0
828.2999877929688, 26.875
829.2000122070312, 48.125
829.5999755859375, 38.125
830.2999877929688, 40.0
830.9000244140625, 37.5
831.7999877929688, 42.5
832.5, 14.375
835.5999755859375, 8.125
836.4000244140625, 29.375
837.2999877929688, 26.875
837.9000244140625, 33.125
838.5, 46.25
839.2000122070312, 36.25
839.7999877929688, 22.5
841.0, 43.125
842.0, 16.875
842.5999755859375, 44.375
843.2000122070312, 11.875
844.0999755859375, 15.625
844.7999877929688, 5.625
845.4000244140625, 13.125
848.4000244140625, 45.0
849.0, 56.25
850.2999877929688, 48.75
850.7000122070312, 47.5
851.0, 47.5
851.7000122070312, 11.875
852.9000244140625, 15.0
854.5, 17.5
855.0999755859375, 26.875
857.2000122070312, 11.25
858.5999755859375, 14.375
859.9000244140625, 25.0
860.5, 24.375
861.5, 40.0
862.2999877929688, 68.125
863.0999755859375, 69.375
863.7999877929688, 35.625
866.5, 0.625
867.7000122070312, 5.625
868.4000244140625, 1.25
869.0999755859375, 25.0
870.5999755859375, 15.625
871.0999755859375, 24.375
873.0999755859375, 44.375
874.0, 47.5
874.7999877929688, 39.375
875.7999877929688, 21.875
879.0999755859375, 23.75
880.2000122070312, 26.25
881.2000122070312, 20.625
882.2999877929688, 43.125
884.5, 42.5
886.2999877929688, 25.625
887.4000244140625, 11.25
888.5, 31.25
889.5999755859375, 6.25
892.2000122070312, 46.875
893.2999877929688, 43.125
894.2000122070312, 50.0
895.0, 23.75
895.5, 30.0
897.5999755859375, 20.0
898.5999755859375, 33.125
900.5, 28.125
901.4000244140625, 6.25
903.5999755859375, 10.625
904.4000244140625, 34.375
905.0999755859375, 58.125
905.5999755859375, 52.5
906.5, 40.625
907.7999877929688, 3.125
909.5999755859375, 10.625
910.5, 11.875
911.0999755859375, 28.125
911.5999755859375, 53.75
912.2000122070312, 45.625
913.0, 11.875
914.0, 33.75
915.9000244140625, 20.625
916.7000122070312, 61.25
917.5, 51.875
918.4000244140625, 70.0
919.9000244140625, 11.875
923.4000244140625, 9.375
924.5999755859375, 47.5
925.4000244140625, 34.375
926.0999755859375, 67.5
927.7000122070312, 17.5
928.4000244140625, 3.75
929.2999877929688, 31.875
930.2999877929688, 33.125
931.0999755859375, 12.5
931.7000122070312, 2.5
935.2999877929688, 15.625
935.7000122070312, 13.75
936.5, 60.625
937.5, 80.625
938.5999755859375, 29.375
940.2000122070312, 0.625
941.7000122070312, 18.75
942.7999877929688, 12.5
943.7999877929688, 24.375
946.9000244140625, 18.125
947.7999877929688, 47.5
948.2000122070312, 46.875
948.7999877929688, 56.875
949.5999755859375, 62.5
950.2999877929688, 43.75
951.2000122070312, 27.5
952.0, 20.625
956.0, 23.75
956.5, 16.25
957.7999877929688, 39.375
958.7999877929688, 5.625
959.7000122070312, 19.375
961.7000122070312, 65.0
962.9000244140625, 42.5
967.7000122070312, 42.5
968.7999877929688, 43.125
969.7999877929688, 38.125
970.5999755859375, 33.125
971.7000122070312, 25.0
972.2000122070312, 30.625
973.4000244140625, 45.0
974.2000122070312, 46.875
975.2999877929688, 1.875
976.4000244140625, 8.75
978.5999755859375, 2.5
979.2999877929688, 20.625
980.0, 27.5
980.7000122070312, 40.625
981.2999877929688, 55.625
981.9000244140625, 53.125
982.7000122070312, 39.375
985.2000122070312, 31.25
986.5999755859375, 2.5
987.7999877929688, 8.75
988.9000244140625, 5.0
991.0, 16.25
992.5999755859375, 69.375
993.5999755859375, 61.875
994.7999877929688, 5.625
995.2999877929688, 7.5
997.7999877929688, 10.625
999.0999755859375, 16.25
1000.0999755859375, 10.625
1000.5, 0.625
1003.0999755859375, 44.375
1003.7000122070312, 51.875
1004.4000244140625, 48.125
1004.7000122070312, 44.375
1005.4000244140625, 41.875
1006.9000244140625, 21.25
1011.2000122070312, 31.25
1011.5999755859375, 28.75
1012.5999755859375, 48.125
1013.4000244140625, 48.75
1014.5999755859375, 23.75
1015.7999877929688, 21.25
1016.5, 31.875
1017.2000122070312, 28.75
1017.7999877929688, 31.875
1018.9000244140625, 28.125
1019.5, 6.875
1022.4000244140625, 21.25
1023.7999877929688, 51.875
1024.5, 50.625
1025.9000244140625, 31.25
1027.199951171875, 33.75
1029.0, 11.25
1029.800048828125, 23.75
1030.4000244140625, 6.875
1031.0, 11.25
1032.9000244140625, 19.375
1034.9000244140625, 29.375
1035.9000244140625, 48.125
1036.5, 68.125
1037.5, 58.75
1038.800048828125, 33.125
1041.5999755859375, 1.25
1042.5999755859375, 17.5
1043.9000244140625, 24.375
1045.699951171875, 6.875
1047.0, 23.125
1047.699951171875, 54.375
1048.199951171875, 41.875
1048.699951171875, 47.5
1049.300048828125, 35.0
1049.800048828125, 18.125
1054.0, 5.625
1055.300048828125, 31.875
1055.800048828125, 26.875
1056.300048828125, 22.5
1057.699951171875, 48.75
1058.199951171875, 19.375
1059.0, 31.875
1060.300048828125, 45.0
1061.0999755859375, 16.25
1062.0999755859375, 18.75
1062.800048828125, 11.25
1066.0999755859375, 37.5
1067.0, 31.25
1067.9000244140625, 54.375
1068.800048828125, 51.875
1069.5999755859375, 67.5
1070.199951171875, 31.875
1071.0, 19.375
1071.5999755859375, 10.0
1073.800048828125, 8.125
1074.4000244140625, 18.75
1076.5, 11.25
1077.800048828125, 16.875
1079.5999755859375, 61.875
1080.800048828125, 56.25
1082.0999755859375, 38.125
1086.0, 25.0
1086.699951171875, 12.5
1088.0999755859375, 15.625
1088.5999755859375, 11.25
1089.4000244140625, 16.875
1090.300048828125, 51.25
1091.0999755859375, 46.25
1092.5999755859375, 57.5
1093.199951171875, 37.5
1094.0999755859375, 16.875
1098.9000244140625, 3.125
1099.300048828125, 21.875
1100.0, 58.75
1100.699951171875, 45.0
1101.800048828125, 30.625
1103.800048828125, 40.625
1104.800048828125, 22.5
1105.800048828125, 5.625
1106.300048828125, 21.875
1107.0, 5.625
1109.199951171875, 12.5
1109.9000244140625, 11.875
1110.300048828125, 14.375
1111.5, 44.375
1112.199951171875, 55.0
1113.300048828125, 37.5
1114.300048828125, 11.875
1115.300048828125, 19.375
1116.5999755859375, 10.0
1117.699951171875, 13.75
1118.0999755859375, 11.875
1119.4000244140625, 8.75
1121.800048828125, 16.25
1122.4000244140625, 16.875
1123.5, 34.375
1124.4000244140625, 69.375
1125.300048828125, 33.125
1126.5999755859375, 24.375
1129.800048828125, 18.75
1130.300048828125, 30.0
1131.199951171875, 15.625
1131.9000244140625, 38.75
1132.800048828125, 6.25
1134.0, 13.125
1134.199951171875, 12.5
1135.0, 33.125
1136.0, 53.75
1136.699951171875, 50.0
1137.199951171875, 35.625
1138.0999755859375, 13.75
1141.199951171875, 3.125
1142.0999755859375, 20.625
1142.5, 16.875
1143.0999755859375, 40.625
1144.300048828125, 53.125
1145.0999755859375, 13.75
1145.800048828125, 39.375
1146.5999755859375, 33.75
1147.300048828125, 33.75
1148.5, 24.375
1149.5, 24.375
1151.699951171875, 11.25
1153.4000244140625, 8.125
1154.199951171875, 8.125
1155.9000244140625, 66.25
1156.800048828125, 70.625
1157.699951171875, 17.5
1160.0999755859375, 16.25
1161.0999755859375, 5.625
1162.300048828125, 3.125
1163.199951171875, 23.125
1164.0, 0.625
1166.5999755859375, 39.375
1167.0, 47.5
1168.0, 50.625
1168.5999755859375, 49.375
1169.199951171875, 25.0
1169.9000244140625, 30.625
1173.4000244140625, 20.625
1175.0999755859375, 25.0
1175.699951171875, 8.75
1176.199951171875, 26.25
1176.699951171875, 38.125
1177.5, 25.0
1179.0, 48.125
1180.199951171875, 13.75
1181.5, 50.625
1186.5, 53.125
1187.5999755859375, 63.125
1189.0999755859375, 20.0
1190.5, 20.0
1191.0, 23.75
1191.699951171875, 34.375
1192.199951171875, 26.875
1192.800048828125, 33.75
1193.699951171875, 20.625
1194.699951171875, 1.875
1197.4000244140625, 25.625
1198.5, 48.125
1199.300048828125, 54.375
1200.300048828125, 56.25
1200.9000244140625, 43.125
1202.4000244140625, 16.25
1203.5999755859375, 26.875
1204.0, 17.5
1205.199951171875, 13.125
1205.800048828125, 1.875
1206.5999755859375, 11.875
1207.800048828125, 15.625
1208.800048828125, 15.625
1210.0, 22.5
1211.300048828125, 76.875
1212.199951171875, 53.125
1212.9000244140625, 45.0
1213.699951171875, 31.875
1216.800048828125, 18.125
1217.5999755859375, 9.375
1218.5999755859375, 33.125
1219.0, 29.375
1219.5, 29.375
1221.699951171875, 23.75
1222.699951171875, 38.125
1223.800048828125, 81.25
1225.0999755859375, 18.75
1229.699951171875, 21.25
1230.4000244140625, 38.75
1231.4000244140625, 41.25
1232.0999755859375, 59.375
1232.699951171875, 23.125
1233.699951171875, 16.875
1235.0, 52.5
1236.199951171875, 6.25
1236.800048828125, 19.375
1241.199951171875, 30.625
1241.800048828125, 35.0
1242.800048828125, 60.0
1243.800048828125, 84.375
1244.4000244140625, 40.625
1244.9000244140625, 46.875
1245.699951171875, 4.375
1247.4000244140625, 25.0
1248.0, 22.5
1248.800048828125, 5.0
1249.9000244140625, 42.5
1253.5999755859375, 51.25
1254.5, 60.625
1255.0999755859375, 83.75
1255.800048828125, 68.75
1256.5999755859375, 55.625
1257.699951171875, 15.625
1259.9000244140625, 6.875
1261.800048828125, 15.625
1262.699951171875, 12.5
1264.0, 31.25
1265.0, 30.625
1266.0, 34.375
1266.5999755859375, 66.25
1267.0, 61.25
1268.0, 82.5
1268.800048828125, 25.0
1269.9000244140625, 18.125
1273.4000244140625, 38.75
1274.300048828125, 53.125
1274.699951171875, 55.625
1275.300048828125, 31.25
1276.0, 45.0
1277.5, 26.875
1278.5, 46.25
1278.9000244140625, 49.375
1280.5, 10.625
1284.5, 0.0
1285.0999755859375, 23.125
1286.0, 45.0
1286.699951171875, 55.625
1287.0999755859375, 53.75
1288.0999755859375, 49.375
1288.699951171875, 38.75
1289.199951171875, 23.125
1291.0, 16.25
1291.9000244140625, 11.875
1293.199951171875, 6.875
1297.199951171875, 31.25
1298.0, 60.625
1298.699951171875, 49.375
1299.9000244140625, 56.25
1300.300048828125, 60.0
1300.699951171875, 65.625
1304.0999755859375, 2.5
1304.800048828125, 18.125
1305.300048828125, 12.5
1306.4000244140625, 13.75
1307.5, 41.875
1308.5, 38.75
1309.699951171875, 46.25
1310.300048828125, 70.625
1311.800048828125, 55.625
1312.699951171875, 8.75
1316.800048828125, 40.625
1318.0, 36.875
1318.4000244140625, 30.0
1319.5999755859375, 71.25
1321.0999755859375, 34.375
1321.4000244140625, 29.375
1322.199951171875, 26.25
1323.0999755859375, 30.625
1323.699951171875, 19.375
1324.699951171875, 22.5
1328.699951171875, 8.125
1329.5999755859375, 76.875
1330.0999755859375, 85.0
1331.0999755859375, 55.0
1331.800048828125, 54.375
1333.0999755859375, 22.5
1334.4000244140625, 20.625
1335.5999755859375, 10.0
1336.4000244140625, 20.625
1340.5999755859375, 30.625
1341.300048828125, 54.375
1342.5, 85.625
1343.5999755859375, 35.625
1344.199951171875, 13.125
1345.0999755859375, 0.0
1350.5, 26.25
1351.0999755859375, 44.375
1351.800048828125, 15.625
1352.699951171875, 59.375
1353.5, 47.5
1354.5, 81.25
1355.5999755859375, 36.875
1359.800048828125, 31.25
1360.4000244140625, 0.625
1361.800048828125, 58.125
1363.5999755859375, 58.125
1364.4000244140625, 31.875
1365.5, 74.375
1366.5999755859375, 40.0
1366.9000244140625, 39.375
1368.800048828125, 8.125
1372.300048828125, 30.625
1373.4000244140625, 51.25
1374.0, 46.875
1374.800048828125, 46.875
1375.800048828125, 77.5
1376.699951171875, 44.375
1378.0, 3.125
1381.0999755859375, 8.75
1383.4000244140625, 3.125
1383.9000244140625, 18.125
1384.800048828125, 62.5
1385.9000244140625, 80.0
1386.9000244140625, 73.75
1387.5999755859375, 66.875
1391.699951171875, 8.125
1392.800048828125, 13.125
1393.199951171875, 15.0
1394.0, 12.5
1394.800048828125, 40.0
1395.199951171875, 31.875
1396.0, 39.375
1396.300048828125, 39.375
1397.199951171875, 58.125
1397.699951171875, 48.75
1398.4000244140625, 61.875
1399.4000244140625, 23.75
1404.199951171875, 10.0
1404.699951171875, 17.5
1405.699951171875, 48.75
1406.4000244140625, 49.375
1407.0999755859375, 36.25
1408.199951171875, 38.75
1409.5999755859375, 17.5
1410.5, 51.875
1416.699951171875, 45.0
1418.0999755859375, 51.875
1419.0999755859375, 100.0
1421.5, 0.0
1422.699951171875, 13.125
1423.699951171875, 5.0
1427.0, 10.625
1427.5, 18.125
1428.300048828125, 43.125
1429.0, 50.0
1430.0, 86.25
1430.699951171875, 61.25
1432.199951171875, 33.75
1435.800048828125, 2.5
1437.0999755859375, 7.5
1437.699951171875, 18.125
1438.4000244140625, 35.625
1439.5999755859375, 40.625
1440.5999755859375, 60.0
1441.0, 58.75
1442.0999755859375, 32.5
1442.699951171875, 28.75
1443.199951171875, 27.5
1443.5999755859375, 36.25
1447.800048828125, 23.75
1449.300048828125, 76.875
##PAGE=T= 0.017366666666666666
##XYDATA=(XY..XY)
100.4000015258789, 1.7247844019497565
103.19999694824219, 8.998875140607424
104.9000015258789, 1.2748406449193852
106.4000015258789, 12.523434570678665
107.5, 0.8248968878890139
109.0999984741211, 0.562429696287964
111.0999984741211, 31.046119235095617
112.5, 41.31983502062243
113.0999984741211, 20.622422197225347
114.30000305175781, 5.961754780652419
115.19999694824219, 0.11248593925759282
117.0, 6.074240719910011
118.0, 1.7247844019497565
118.80000305175781, 0.5249343832020997
119.9000015258789, 8.323959505061868
120.5999984741211, 5.2493438320209975
121.30000305175781, 0.44994375703037126
122.30000305175781, 1.7622797150356206
123.0999984741211, 2.324709411323585
123.4000015258789, 2.1372328458942635
124.0999984741211, 1.5373078365204351
124.69999694824219, 2.924634420697413
125.69999694824219, 2.5121859767529062
127.0, 9.823772028496439
128.3000030517578, 9.861267341582304
129.0, 3.449568803899513
129.89999389648438, 1.687289088863892
130.5, 3.4120734908136483
131.10000610351562, 8.998875140607424
132.60000610351562, 3.9745031871016128
133.1999969482422, 5.88676415448069
134.60000610351562, 13.910761154855644
136.60000610351562, 25.23434570678665
137.1999969482422, 17.885264341957257
138.39999389648438, 9.22384701912261
139.3000030517578, 5.099362579677541
142.10000610351562, 5.399325084364455
143.89999389648438, 3.899512560929884
146.6999969482422, 20.547431571053618
147.5, 1.9872515935508064
148.1999969482422, 7.874015748031496
149.39999389648438, 1.0498687664041995
150.10000610351562, 1.2373453318335208
150.5, 0.8998875140607425
151.3000030517578, 1.0123734533183353
152.8000030517578, 9.29883764529434
154.89999389648438, 44.8068991376078
156.60000610351562, 1.8747656542932134
157.39999389648438, 6.1492313460817405
158.0, 4.64941882264717
159.1999969482422, 16.87289088863892
160.1999969482422, 27.334083239595053
162.8000030517578, 19.8350206224222
164.3000030517578, 11.32358455193101
165.6999969482422, 8.398950131233596
166.6999969482422, 5.736782902137233
167.89999389648438, 2.5871766029246346
168.5, 4.499437570303712
169.39999389648438, 1.9122609673790778
170.0, 5.1368578927634045
171.5, 3.9745031871016128
172.1999969482422, 8.061492313460818
173.10000610351562, 3.1496062992125986
173.89999389648438, 1.2748406449193852
175.1999969482422, 9.29883764529434
176.5, 5.549306336707912
177.1999969482422, 5.62429696287964
178.6999969482422, 27.559055118110237
179.5, 9.673790776152982
180.39999389648438, 10.648668916385452
181.39999389648438, 25.609298837645294
182.89999389648438, 0.6374203224596926
184.6999969482422, 1.5373078365204351
186.0, 3.899512560929884
186.6999969482422, 5.961754780652419
188.1999969482422, 6.224221972253469
189.0, 0.4874390701162355
190.39999389648438, 20.172478440194975
192.39999389648438, 12.11098612673416
195.0, 5.62429696287964
196.0, 6.4866891638545185
197.60000610351562, 17.810273715785527
198.5, 2.0622422197225347
199.3000030517578, 1.8372703412073492
200.3000030517578, 1.6122984626921635
201.1999969482422, 3.0746156730408702
202.0, 6.4866891638545185
202.89999389648438, 0.33745781777277845
204.1999969482422, 11.023622047244094
205.10000610351562, 11.77352830896138
207.0, 20.697412823397077
208.39999389648438, 8.43644544431946
209.1999969482422, 2.4746906636670416
210.10000610351562, 13.87326584176978
210.89999389648438, 6.374203224596926
212.39999389648438, 13.123359580052494
213.60000610351562, 2.6996625421822276
216.3000030517578, 7.049118860142483
217.10000610351562, 2.924634420697413
218.60000610351562, 19.047619047619047
219.60000610351562, 1.2373453318335208
222.39999389648438, 17.397825271841022
223.10000610351562, 7.72403449568804
224.39999389648438, 0.9373828271466067
225.60000610351562, 12.82339707536558
227.1999969482422, 8.548931383577054
228.5, 11.211098612673416
229.8000030517578, 10.723659542557181
231.0, 5.211848518935134
232.10000610351562, 0.562429696287964
232.39999389648438, 0.5249343832020997
232.89999389648438, 0.18747656542932134
234.8000030517578, 1.4248218972628421
235.39999389648438, 1.0123734533183353
236.5, 3.1496062992125986
238.3000030517578, 31.08361454818148
238.8000030517578, 17.510311211098614
240.60000610351562, 12.860892388451445
242.1999969482422, 2.9621297337832773
242.89999389648438, 3.8245219347581556
243.6999969482422, 7.3865766779152615
244.6999969482422, 14.623172103487065
246.5, 5.324334458192726
247.10000610351562, 1.387326584176978
248.60000610351562, 9.48631421072366
250.10000610351562, 4.199475065616798
250.39999389648438, 4.311961004874391
251.3000030517578, 3.487064116985377
252.0, 2.5871766029246346
253.3000030517578, 14.84814398200225
254.39999389648438, 1.8747656542932134
255.39999389648438, 3.2620922384701916
256.5, 10.836145481814773
258.20001220703125, 17.13535808023997
259.70001220703125, 3.1121109861267344
260.70001220703125, 2.362204724409449
261.70001220703125, 2.249718785151856
262.79998779296875, 3.937007874015748
263.3999938964844, 1.9872515935508064
266.1000061035156, 0.8998875140607425
267.1000061035156, 8.773903262092238
267.70001220703125, 2.3997000374953132
268.70001220703125, 10.611173603299589
270.5, 8.473940757405325
272.20001220703125, 1.799775028121485
273.1000061035156, 1.387326584176978
274.3999938964844, 10.723659542557181
276.0, 19.460067491563557
277.29998779296875, 5.399325084364455
278.6000061035156, 18.785151856018
279.20001220703125, 9.74878140232471
280.70001220703125, 14.360704911886016
282.20001220703125, 21.034870641169856
284.29998779296875, 14.023247094113236
284.8999938964844, 16.272965879265094
286.6000061035156, 9.448818897637796
287.20001220703125, 1.5748031496062993
288.3999938964844, 0.974878140232471
289.3999938964844, 0.7124109486314211
289.79998779296875, 0.22497187851518563
290.29998779296875, 0.14998125234345708
291.3999938964844, 7.911511061117361
292.20001220703125, 1.9872515935508064
294.0, 11.661042369703788
295.5, 6.749156355455568
298.1000061035156, 9.823772028496439
299.0, 2.4371953505811774
299.8999938964844, 1.1623547056617924
300.8999938964844, 6.67416572928384
301.3999938964844, 3.5245594300712413
302.5, 0.22497187851518563
304.5, 24.259467566554182
305.1000061035156, 5.061867266591676
306.3999938964844, 0.8623922009748782
307.1000061035156, 0.7124109486314211
308.3999938964844, 0.7874015748031497
309.6000061035156, 22.83464566929134
310.6000061035156, 1.9872515935508064
311.6000061035156, 4.424446944131984
312.6000061035156, 0.22497187851518563
314.29998779296875, 0.33745781777277845
316.1000061035156, 12.185976752905887
317.6000061035156, 18.822647169103863
318.5, 20.209973753280842
320.8999938964844, 6.074240719910011
322.5, 17.02287214098238
323.3999938964844, 1.8747656542932134
323.79998779296875, 1.6122984626921635
325.70001220703125, 34.60817397825272
326.5, 34.34570678665167
327.29998779296875, 6.449193850768654
328.20001220703125, 31.046119235095617
329.70001220703125, 2.9996250468691414
330.8999938964844, 31.2710911136108
331.70001220703125, 1.7247844019497565
334.79998779296875, 1.387326584176978
335.29998779296875, 2.662167229096363
336.8999938964844, 2.249718785151856
338.5, 5.8117735283089615
340.0, 3.2995875515560558
341.6000061035156, 39.78252718410199
342.29998779296875, 12.598425196850394
343.20001220703125, 1.387326584176978
343.6000061035156, 1.9872515935508064
344.8999938964844, 5.0243719535058124
345.3999938964844, 3.7870266216722914
348.5, 19.197600299962506
349.20001220703125, 2.212223472065992
350.20001220703125, 12.935883014623172
351.6000061035156, 1.2373453318335208
352.6000061035156, 10.573678290213724
353.20001220703125, 3.6370453693288343
355.5, 19.49756280464942
357.20001220703125, 24.109486314210724
359.6000061035156, 2.4371953505811774
360.70001220703125, 2.099737532808399
361.20001220703125, 2.1747281589801277
362.20001220703125, 1.6497937757780279
363.3999938964844, 19.010123734533185
364.20001220703125, 21.747281589801275
365.6000061035156, 9.636295463067118
367.20001220703125, 17.585301837270343
368.29998779296875, 2.212223472065992
368.70001220703125, 1.799775028121485
370.1000061035156, 1.4998125234345707
370.6000061035156, 1.9872515935508064
371.6000061035156, 14.92313460817398
372.6000061035156, 6.299212598425197
374.79998779296875, 6.261717285339333
376.3999938964844, 9.936257967754031
377.3999938964844, 9.561304836895388
378.20001220703125, 10.048743907011625
379.29998779296875, 1.6122984626921635
380.3999938964844, 10.686164229471316
381.29998779296875, 1.6122984626921635
382.5, 3.0371203599550056
383.6000061035156, 7.536557930258718
384.5, 3.0371203599550056
385.29998779296875, 2.2872140982377203
386.6000061035156, 7.911511061117361
387.29998779296875, 2.5871766029246346
390.3999938964844, 13.048368953880766
391.20001220703125, 17.735283089613798
393.1000061035156, 13.835770528683915
395.20001220703125, 14.435695538057743
397.79998779296875, 2.212223472065992
399.20001220703125, 17.99775028121485
400.5, 2.774653168353956
403.3999938964844, 8.51143607049119
404.0, 4.0119985001874765
404.8999938964844, 2.774653168353956
406.70001220703125, 1.124859392575928
407.70001220703125, 3.0746156730408702
409.20001220703125, 0.6749156355455569
411.20001220703125, 10.573678290213724
412.3999938964844, 2.7371578552680917
414.20001220703125, 17.92275965504312
416.20001220703125, 2.4371953505811774
416.79998779296875, 2.4746906636670416
417.3999938964844, 1.7247844019497565
418.8999938964844, 1.124859392575928
419.3999938964844, 1.2748406449193852
420.8999938964844, 0.33745781777277845
421.8999938964844, 0.6374203224596926
423.20001220703125, 2.362204724409449
423.79998779296875, 2.212223472065992
425.8999938964844, 16.87289088863892
427.29998779296875, 0.974878140232471
427.70001220703125, 1.0873640794900639
428.79998779296875, 2.4371953505811774
430.5, 6.111736032995876
432.8999938964844, 21.672290963629546
433.5, 5.211848518935134
434.70001220703125, 1.4623172103487065
435.79998779296875, 1.124859392575928
437.0, 10.123734533183352
437.70001220703125, 1.4248218972628421
438.5, 1.2373453318335208
439.8999938964844, 36.145481814773156
441.1000061035156, 1.1623547056617924
442.5, 7.3865766779152615
443.20001220703125, 2.662167229096363
443.79998779296875, 6.67416572928384
444.79998779296875, 0.6374203224596926
446.70001220703125, 38.80764904386952
448.6000061035156, 1.5373078365204351
449.3999938964844, 0.6749156355455569
450.5, 5.286839145106862
451.29998779296875, 0.3749531308586427
453.6000061035156, 1.2373453318335208
454.8999938964844, 6.074240719910011
456.6000061035156, 6.299212598425197
459.79998779296875, 4.5744281964754405
461.5, 2.5121859767529062
463.1000061035156, 8.586426696662917
464.70001220703125, 11.923509561304838
465.6000061035156, 0.3749531308586427
467.0, 10.873640794900638
468.3999938964844, 2.81214848143982
470.20001220703125, 10.161229846269217
472.20001220703125, 1.6497937757780279
474.0, 32.62092238470191
475.5, 1.2748406449193852
476.29998779296875, 0.14998125234345708
477.79998779296875, 31.2710911136108
478.6000061035156, 9.261342332208475
480.5, 2.212223472065992
481.3999938964844, 10.086239220097488
482.6000061035156, 0.22497187851518563
484.3999938964844, 4.199475065616798
485.6000061035156, 2.249718785151856
486.3999938964844, 1.1623547056617924
487.5, 10.048743907011625
489.1000061035156, 4.986876640419948
490.70001220703125, 15.785526809148857
491.79998779296875, 1.8747656542932134
493.20001220703125, 11.24859392575928
494.1000061035156, 1.6497937757780279
495.3999938964844, 0.07499062617172854
497.1000061035156, 1.5373078365204351
497.6000061035156, 1.2373453318335208
498.0, 1.6497937757780279
498.70001220703125, 2.662167229096363
499.5, 1.6122984626921635
500.3999938964844, 0.7874015748031497
501.3999938964844, 0.0
503.6000061035156, 1.124859392575928
505.1000061035156, 15.860517435320586
505.8999938964844, 0.22497187851518563
506.3999938964844, 1.0873640794900639
508.79998779296875, 8.811398575178103
509.3999938964844, 1.5748031496062993
511.20001220703125, 28.046494188226472
512.0, 1.6497937757780279
513.5, 0.8248968878890139
514.7000122070312, 21.859767529058868
517.2999877929688, 23.697037870266218
519.9000244140625, 11.098612673415824
520.7000122070312, 12.973378327709037
522.2000122070312, 1.687289088863892
523.0, 3.33708286464192
524.2000122070312, 2.212223472065992
526.5, 7.911511061117361
527.0, 5.699287589051369
527.5999755859375, 6.1492313460817405
528.2999877929688, 1.5373078365204351
529.2000122070312, 2.887139107611549
531.0, 35.9955005624297
531.7000122070312, 0.4874390701162355
532.5, 1.4623172103487065
533.5, 15.748031496062993
534.0, 6.67416572928384
535.5, 18.222722159730036
536.2000122070312, 22.797150356205474
536.9000244140625, 1.1998500187476566
537.5, 1.7247844019497565
538.2999877929688, 0.07499062617172854
538.7999877929688, 0.562429696287964
539.5, 0.5999250093738283
541.5, 8.736407949006376
543.2000122070312, 10.123734533183352
544.0, 13.723284589426322
545.0, 6.7116610423697045
545.7000122070312, 1.4248218972628421
546.7000122070312, 12.373453318335208
547.9000244140625, 1.6122984626921635
548.5999755859375, 2.4746906636670416
550.5, 27.371578552680916
552.4000244140625, 1.3498312710911138
554.0, 7.686539182602175
556.0999755859375, 14.960629921259844
556.7000122070312, 17.247844019497563
557.7999877929688, 8.548931383577054
559.4000244140625, 1.7622797150356206
560.0, 2.324709411323585
560.5999755859375, 2.099737532808399
561.5, 2.6996625421822276
562.7999877929688, 0.5999250093738283
564.5, 9.22384701912261
566.7999877929688, 10.086239220097488
568.0, 0.9373828271466067
568.5999755859375, 1.9872515935508064
569.4000244140625, 1.0123734533183353
571.2999877929688, 14.360704911886016
572.7000122070312, 12.223472065991752
574.0999755859375, 24.14698162729659
574.9000244140625, 2.212223472065992
578.7000122070312, 9.973753280839896
579.7000122070312, 1.4998125234345707
580.5, 2.2872140982377203
581.2000122070312, 0.7874015748031497
581.9000244140625, 1.4248218972628421
583.2000122070312, 16.197975253093365
584.2000122070312, 0.5249343832020997
585.0, 1.4623172103487065
587.0999755859375, 11.77352830896138
588.7000122070312, 6.1492313460817405
591.2000122070312, 47.16910386201725
592.2000122070312, 23.472065991751034
592.9000244140625, 18.485189351331083
594.4000244140625, 7.011623547056618
595.0999755859375, 1.124859392575928
596.5, 43.04461942257218
597.4000244140625, 1.3123359580052494
598.7999877929688, 7.349081364829397
599.7999877929688, 0.33745781777277845
600.4000244140625, 0.6749156355455569
603.0, 16.047994000749906
603.7999877929688, 1.3123359580052494
605.2999877929688, 18.897637795275593
606.2999877929688, 2.212223472065992
607.0999755859375, 0.5999250093738283
607.4000244140625, 0.4874390701162355
608.2000122070312, 0.26246719160104987
610.0, 0.4874390701162355
611.7999877929688, 11.736032995875517
612.5, 1.8747656542932134
615.7999877929688, 15.37307836520435
616.9000244140625, 1.4248218972628421
617.4000244140625, 2.6996625421822276
618.5, 2.212223472065992
621.0999755859375, 5.549306336707912
622.2000122070312, 2.3997000374953132
622.7999877929688, 1.7247844019497565
624.2999877929688, 16.460442444694415
625.7000122070312, 5.174353205849269
628.5, 1.0498687664041995
629.4000244140625, 1.2748406449193852
631.0999755859375, 2.1372328458942635
631.9000244140625, 0.7499062617172854
633.0, 0.6374203224596926
634.4000244140625, 0.14998125234345708
635.2000122070312, 3.224596925384327
635.9000244140625, 2.099737532808399
636.7999877929688, 0.8623922009748782
637.4000244140625, 2.099737532808399
638.0, 3.6370453693288343
641.2000122070312, 15.673040869891265
642.4000244140625, 3.224596925384327
643.2999877929688, 1.387326584176978
643.9000244140625, 1.0873640794900639
646.2000122070312, 7.874015748031496
647.2999877929688, 6.4866891638545185
648.0999755859375, 3.5245594300712413
649.0999755859375, 2.099737532808399
650.0999755859375, 2.3997000374953132
653.0999755859375, 8.43644544431946
653.7000122070312, 1.8747656542932134
654.2000122070312, 2.0247469066366706
656.0, 23.95950506186727
657.2999877929688, 0.29996250468691416
658.0, 0.7874015748031497
659.0, 0.8623922009748782
659.7999877929688, 2.7371578552680917
660.9000244140625, 1.1623547056617924
662.5, 9.898762654668166
663.5999755859375, 1.1998500187476566
666.2999877929688, 3.899512560929884
667.2999877929688, 13.535808023997001
668.5, 8.998875140607424
669.5, 0.5249343832020997
670.7999877929688, 8.43644544431946
672.2000122070312, 31.19610048743907
673.2999877929688, 27.446569178852645
675.0, 0.7874015748031497
675.9000244140625, 0.07499062617172854
676.7999877929688, 4.2369703787026625
678.5, 3.33708286464192
679.7999877929688, 2.5121859767529062
681.0999755859375, 12.56092988376453
681.7999877929688, 1.0498687664041995
682.4000244140625, 0.14998125234345708
683.9000244140625, 1.1623547056617924
684.7999877929688, 1.4998125234345707
685.7000122070312, 1.6122984626921635
687.0999755859375, 2.1372328458942635
687.5999755859375, 1.6122984626921635
688.5999755859375, 0.4874390701162355
690.5999755859375, 0.6749156355455569
691.4000244140625, 0.974878140232471
692.0, 2.6246719160104988
692.7999877929688, 4.761904761904762
694.7000122070312, 12.073490813648295
696.0999755859375, 0.5999250093738283
697.4000244140625, 3.8245219347581556
698.2000122070312, 1.7247844019497565
699.0, 1.687289088863892
700.5, 26.35920509936258
702.2000122070312, 23.134608173978254
703.7000122070312, 4.9118860142482195
706.2999877929688, 9.186351706036746
707.2999877929688, 7.874015748031496
708.4000244140625, 0.11248593925759282
709.5, 1.6122984626921635
711.0, 5.699287589051369
712.2999877929688, 7.761529808773904
713.4000244140625, 0.29996250468691416
715.0, 14.435695538057743
715.7000122070312, 1.0498687664041995
716.7999877929688, 18.485189351331083
717.2000122070312, 16.497937757780278
718.0, 1.9122609673790778
718.4000244140625, 2.099737532808399
719.4000244140625, 5.999250093738283
720.4000244140625, 1.0873640794900639
720.9000244140625, 0.29996250468691416
722.7000122070312, 3.2995875515560558
724.2000122070312, 8.173978252718411
724.9000244140625, 1.4623172103487065
725.5999755859375, 0.14998125234345708
727.0, 11.061117360329959
728.2999877929688, 1.4623172103487065
729.4000244140625, 3.7870266216722914
730.0, 1.799775028121485
731.2999877929688, 13.760779902512187
733.7999877929688, 1.1998500187476566
734.2999877929688, 1.5748031496062993
735.2999877929688, 2.5496812898387704
736.5, 10.273715785526809
737.0, 8.361454818147733
739.2999877929688, 0.5999250093738283
740.0, 0.6749156355455569
741.0, 3.33708286464192
742.2000122070312, 4.64941882264717
742.9000244140625, 8.548931383577054
744.2000122070312, 2.887139107611549
747.7000122070312, 8.023997000374953
748.5, 2.3997000374953132
749.0999755859375, 1.6497937757780279
750.2000122070312, 0.14998125234345708
751.4000244140625, 0.5999250093738283
752.7999877929688, 0.8623922009748782
754.7999877929688, 20.322459692538434
756.7000122070312, 2.212223472065992
760.2999877929688, 9.448818897637796
761.5, 1.6497937757780279
762.0999755859375, 1.5373078365204351
763.0, 1.4998125234345707
764.9000244140625, 2.249718785151856
765.4000244140625, 2.249718785151856
767.5, 12.11098612673416
768.2999877929688, 1.8372703412073492
769.2000122070312, 5.88676415448069
770.7999877929688, 1.4623172103487065
771.7999877929688, 1.4998125234345707
772.5, 1.5748031496062993
773.5, 2.5496812898387704
774.7000122070312, 1.5373078365204351
776.2999877929688, 3.374578177727784
777.7000122070312, 0.6374203224596926
778.7999877929688, 1.124859392575928
779.5999755859375, 2.9621297337832773
781.7999877929688, 19.91001124859393
783.2000122070312, 23.95950506186727
783.9000244140625, 3.33708286464192
784.5, 7.986501687289089
785.5, 2.324709411323585
786.4000244140625, 6.824146981627297
789.2999877929688, 16.347956505436823
790.0999755859375, 1.0873640794900639
790.7000122070312, 1.4248218972628421
792.0999755859375, 29.95875515560555
793.0999755859375, 1.1623547056617924
793.9000244140625, 0.562429696287964
795.5999755859375, 18.785151856018
796.5, 1.2373453318335208
797.4000244140625, 1.6497937757780279
799.4000244140625, 12.148481439820022
800.0999755859375, 1.7622797150356206
802.2000122070312, 1.1998500187476566
803.4000244140625, 12.785901762279716
804.0999755859375, 14.360704911886016
804.9000244140625, 16.197975253093365
806.0, 1.4998125234345707
807.4000244140625, 4.724409448818898
808.5999755859375, 0.44994375703037126
810.0999755859375, 5.286839145106862
810.7000122070312, 2.887139107611549
811.5, 2.6246719160104988
812.5999755859375, 4.424446944131984
813.2000122070312, 10.986126734158232
816.2999877929688, 5.436820397450319
817.7999877929688, 13.08586426696663
818.7000122070312, 1.4998125234345707
821.0999755859375, 13.835770528683915
822.5, 2.5496812898387704
823.7000122070312, 8.061492313460818
824.5999755859375, 0.5999250093738283
825.2000122070312, 0.3749531308586427
825.5, 0.4874390701162355
826.2999877929688, 1.3123359580052494
827.7000122070312, 12.223472065991752
829.0999755859375, 2.0247469066366706
829.5999755859375, 0.8623922009748782
830.4000244140625, 1.3123359580052494
830.7999877929688, 1.4998125234345707
831.7999877929688, 0.8248968878890139
833.5999755859375, 3.374578177727784
834.5999755859375, 0.7499062617172854
835.5999755859375, 1.4998125234345707
836.4000244140625, 0.8248968878890139
836.9000244140625, 0.22497187851518563
838.2000122070312, 1.6497937757780279
840.0999755859375, 1.0498687664041995
840.9000244140625, 2.5121859767529062
842.0999755859375, 11.473565804274466
843.4000244140625, 1.799775028121485
844.7999877929688, 13.34833145856768
845.7000122070312, 1.5373078365204351
846.0999755859375, 0.4874390701162355
847.4000244140625, 31.496062992125985
848.5, 5.774278215223098
850.0999755859375, 8.173978252718411
850.9000244140625, 0.8248968878890139
851.7000122070312, 12.56092988376453
852.7000122070312, 6.336707911511062
853.7000122070312, 0.9373828271466067
854.0999755859375, 1.2748406449193852
854.7000122070312, 0.8248968878890139
855.5999755859375, 1.4623172103487065
857.0, 5.9242594675665545
857.7000122070312, 0.562429696287964
859.5, 1.4248218972628421
860.2999877929688, 0.22497187851518563
860.9000244140625, 1.7247844019497565
861.5999755859375, 1.2748406449193852
862.5999755859375, 2.2872140982377203
864.0, 0.5999250093738283
865.7999877929688, 0.974878140232471
866.9000244140625, 1.3498312710911138
869.0999755859375, 9.523809523809524
871.2000122070312, 0.562429696287964
873.0999755859375, 5.286839145106862
874.0, 6.7116610423697045
876.0999755859375, 5.511811023622047
878.0999755859375, 1.6122984626921635
879.2000122070312, 6.186726659167604
879.9000244140625, 1.687289088863892
881.0, 2.3997000374953132
881.9000244140625, 2.1747281589801277
883.5999755859375, 0.26246719160104987
884.2999877929688, 0.562429696287964
886.2999877929688, 24.671916010498688
887.0999755859375, 1.5748031496062993
888.5999755859375, 4.949381327334083
890.2999877929688, 0.7124109486314211
892.4000244140625, 8.811398575178103
893.0999755859375, 1.8747656542932134
895.5, 0.26246719160104987
897.2999877929688, 4.499437570303712
898.7000122070312, 6.374203224596926
899.5, 6.4866891638545185
900.2999877929688, 0.18747656542932134
901.7000122070312, 0.6749156355455569
902.2999877929688, 1.5748031496062993
903.0999755859375, 2.6996625421822276
904.0, 12.148481439820022
904.7000122070312, 9.29883764529434
908.4000244140625, 0.26246719160104987
910.0, 10.686164229471316
911.0999755859375, 1.0873640794900639
911.9000244140625, 1.6497937757780279
912.4000244140625, 0.5999250093738283
913.9000244140625, 1.1998500187476566
915.0, 0.9373828271466067
915.7999877929688, 3.749531308586427
917.2000122070312, 1.124859392575928
918.2999877929688, 2.0247469066366706
919.4000244140625, 0.14998125234345708
922.4000244140625, 18.147731533558307
923.4000244140625, 1.949756280464942
924.9000244140625, 1.4998125234345707
927.0, 10.161229846269217
927.7999877929688, 7.911511061117361
928.9000244140625, 18.410198725159358
929.7999877929688, 1.6122984626921635
930.7999877929688, 0.41244844394450697
932.7000122070312, 18.410198725159358
935.4000244140625, 12.03599550056243
937.0, 4.9118860142482195
937.9000244140625, 0.562429696287964
938.5999755859375, 0.11248593925759282
940.5999755859375, 31.496062992125985
942.0, 2.324709411323585
942.7000122070312, 2.3997000374953132
943.5999755859375, 1.387326584176978
944.7000122070312, 0.6374203224596926
947.7999877929688, 17.247844019497563
948.9000244140625, 0.6374203224596926
949.2999877929688, 1.2373453318335208
950.2000122070312, 1.124859392575928
950.7999877929688, 0.3749531308586427
953.2000122070312, 14.810648668916386
953.7999877929688, 19.647544056992878
955.0999755859375, 1.0123734533183353
955.9000244140625, 1.7622797150356206
958.0999755859375, 0.562429696287964
959.2000122070312, 2.1372328458942635
960.2999877929688, 4.64941882264717
961.0999755859375, 13.27334083239595
961.7999877929688, 2.4371953505811774
962.5999755859375, 1.3123359580052494
964.7000122070312, 0.562429696287964
965.5, 1.2373453318335208
966.0, 2.249718785151856
967.2999877929688, 4.724409448818898
967.7000122070312, 4.9118860142482195
968.9000244140625, 1.687289088863892
970.7999877929688, 29.021372328458945
972.2999877929688, 1.6122984626921635
973.2999877929688, 1.799775028121485
974.2000122070312, 1.0498687664041995
974.9000244140625, 0.562429696287964
976.9000244140625, 20.172478440194975
978.2000122070312, 1.387326584176978
978.9000244140625, 1.7622797150356206
979.5999755859375, 2.249718785151856
980.4000244140625, 1.5748031496062993
981.2000122070312, 0.44994375703037126
982.4000244140625, 19.310086239220098
983.7000122070312, 6.186726659167604
984.7999877929688, 1.124859392575928
985.5999755859375, 2.3997000374953132
986.7999877929688, 6.524184476940383
988.4000244140625, 3.4120734908136483
990.9000244140625, 15.785526809148857
992.2000122070312, 2.9621297337832773
994.2999877929688, 0.3749531308586427
996.0999755859375, 37.83277090363705
997.5, 2.4746906636670416
998.2000122070312, 4.049493813273341
998.9000244140625, 9.336332958380202
1001.0, 0.0
1001.5999755859375, 1.4623172103487065
1002.7000122070312, 7.574053243344583
1003.7000122070312, 2.4371953505811774
1004.5999755859375, 7.124109486314211
1006.0999755859375, 0.562429696287964
1007.0, 0.22497187851518563
1008.2999877929688, 0.4874390701162355
1009.2999877929688, 1.4998125234345707
1010.0999755859375, 2.324709411323585
1010.9000244140625, 1.4623172103487065
1011.9000244140625, 2.6996625421822276
1012.9000244140625, 13.385826771653544
1015.0999755859375, 1.8372703412073492
1016.0999755859375, 1.7622797150356206
1017.2000122070312, 5.62429696287964
1018.5, 2.0247469066366706
1021.2000122070312, 12.523434570678665
1021.9000244140625, 2.9996250468691414
1022.7000122070312, 2.6996625421822276
1023.5999755859375, 22.75965504311961
1025.0, 6.861642294713161
1025.9000244140625, 0.9373828271466067
1027.199951171875, 0.6749156355455569
1028.300048828125, 0.974878140232471
1029.0, 1.387326584176978
1029.800048828125, 1.9872515935508064
1030.800048828125, 25.90926134233221
1032.0999755859375, 21.52230971128609
1032.9000244140625, 0.8248968878890139
1034.4000244140625, 15.110611173603301
1035.199951171875, 1.387326584176978
1035.800048828125, 1.4623172103487065
1036.9000244140625, 1.4998125234345707
1038.199951171875, 19.23509561304837
1038.9000244140625, 12.11098612673416
1039.9000244140625, 0.8998875140607425
1040.5999755859375, 2.249718785151856
1041.300048828125, 1.8747656542932134
1042.300048828125, 1.0873640794900639
1043.0, 1.6122984626921635
1045.5999755859375, 1.0498687664041995
1047.0999755859375, 2.774653168353956
1048.300048828125, 0.9373828271466067
1049.300048828125, 0.4874390701162355
1053.300048828125, 3.6370453693288343
1054.5999755859375, 25.271841019872518
1055.300048828125, 0.8998875140607425
1055.800048828125, 1.5373078365204351
1056.4000244140625, 0.9373828271466067
1058.0999755859375, 9.22384701912261
1059.199951171875, 1.5373078365204351
1059.699951171875, 1.799775028121485
1061.199951171875, 15.860517435320586
1062.300048828125, 1.949756280464942
1064.300048828125, 7.3865766779152615
1065.0, 0.974878140232471
1066.5999755859375, 25.159355080614926
1067.5, 14.473190851143608
1069.0, 8.773903262092238
1069.5999755859375, 4.874390701162355
1071.300048828125, 0.974878140232471
1071.9000244140625, 3.1496062992125986
1073.0999755859375, 3.4120734908136483
1074.0, 1.0873640794900639
1075.199951171875, 0.33745781777277845
1076.9000244140625, 1.124859392575928
1077.4000244140625, 0.44994375703037126
1078.5, 6.524184476940383
1079.199951171875, 1.9872515935508064
1080.0, 1.5373078365204351
1080.9000244140625, 0.9373828271466067
1081.300048828125, 1.5748031496062993
1083.800048828125, 27.74653168353956
1084.800048828125, 6.899137607799026
1085.5, 2.362204724409449
1086.199951171875, 1.2748406449193852
1086.699951171875, 1.387326584176978
1087.5, 2.362204724409449
1089.5999755859375, 2.324709411323585
1090.4000244140625, 0.03749531308586427
1091.300048828125, 1.2748406449193852
1092.0999755859375, 2.5871766029246346
1092.800048828125, 1.949756280464942
1094.4000244140625, 11.886014248218974
1096.0999755859375, 10.611173603299589
1097.199951171875, 22.42219722534683
1098.300048828125, 1.2373453318335208
1098.9000244140625, 1.6497937757780279
1101.4000244140625, 7.1616047994000755
1103.0999755859375, 1.5748031496062993
1103.5999755859375, 2.1372328458942635
1104.5, 1.8747656542932134
1105.0, 0.29996250468691416
1105.699951171875, 1.6122984626921635
1108.0, 41.432320959880016
1109.5, 1.9872515935508064
1110.0, 1.2373453318335208
1110.699951171875, 1.1998500187476566
1113.199951171875, 12.148481439820022
1114.5999755859375, 5.286839145106862
1115.699951171875, 2.8496437945256843
1116.9000244140625, 2.324709411323585
1118.0, 2.212223472065992
1118.9000244140625, 0.9373828271466067
1121.0999755859375, 5.736782902137233
1122.699951171875, 2.774653168353956
1123.5999755859375, 0.9373828271466067
1125.300048828125, 18.635170603674542
1126.699951171875, 0.03749531308586427
1127.300048828125, 0.4874390701162355
1129.0, 18.560179977502813
1130.699951171875, 15.335583052118487
1132.9000244140625, 35.13310836145482
1134.0, 0.3749531308586427
1134.800048828125, 0.974878140232471
1135.699951171875, 2.81214848143982
1136.5, 1.799775028121485
1137.5999755859375, 1.6497937757780279
1138.4000244140625, 1.687289088863892
1139.0999755859375, 0.0
1139.9000244140625, 1.387326584176978
1140.5, 2.7371578552680917
1141.300048828125, 1.5748031496062993
1143.0, 2.2872140982377203
1143.699951171875, 0.14998125234345708
1145.199951171875, 2.5871766029246346
1146.5999755859375, 6.299212598425197
1148.0999755859375, 20.247469066366705
1149.699951171875, 4.64941882264717
1150.300048828125, 5.8117735283089615
1151.0, 6.67416572928384
1151.9000244140625, 0.44994375703037126
1152.4000244140625, 1.0123734533183353
1153.5999755859375, 13.198350206224223
1154.300048828125, 10.123734533183352
1155.199951171875, 0.974878140232471
1156.0, 0.7874015748031497
1158.5, 1.0498687664041995
1159.199951171875, 0.7499062617172854
1160.199951171875, 2.8496437945256843
1161.0999755859375, 1.687289088863892
1162.5999755859375, 0.33745781777277845
1163.4000244140625, 0.14998125234345708
1164.0999755859375, 1.1623547056617924
1165.0, 0.11248593925759282
1166.5, 21.59730033745782
1167.199951171875, 1.124859392575928
1168.0999755859375, 8.136482939632547
1169.800048828125, 10.123734533183352
1172.4000244140625, 9.711286089238845
1172.9000244140625, 12.185976752905887
1174.5999755859375, 5.1368578927634045
1175.300048828125, 7.349081364829397
1176.699951171875, 6.1492313460817405
1178.4000244140625, 13.010873640794902
1179.4000244140625, 2.1372328458942635
1180.4000244140625, 4.311961004874391
1181.0, 5.511811023622047
1182.9000244140625, 5.3618297712785905
1184.0999755859375, 0.26246719160104987
1185.199951171875, 10.873640794900638
1186.800048828125, 25.72178477690289
1188.699951171875, 0.974878140232471
1189.199951171875, 0.5249343832020997
1190.0, 0.03749531308586427
1191.0, 2.662167229096363
1191.800048828125, 2.212223472065992
1192.800048828125, 2.0622422197225347
1193.5, 1.1623547056617924
1194.0999755859375, 1.124859392575928
1196.699951171875, 27.821522309711288
1197.699951171875, 1.6122984626921635
1198.5999755859375, 12.898387701537308
1199.5, 2.3997000374953132
1201.699951171875, 6.1492313460817405
1203.5999755859375, 11.698537682789652
1204.5999755859375, 5.88676415448069
1205.5999755859375, 1.8372703412073492
1206.300048828125, 0.41244844394450697
1207.800048828125, 18.11023622047244
1210.0, 5.0243719535058124
1211.800048828125, 14.473190851143608
1213.0999755859375, 0.974878140232471
1214.5, 11.698537682789652
1216.4000244140625, 9.261342332208475
1220.0999755859375, 14.360704911886016
1220.800048828125, 0.29996250468691416
1221.199951171875, 0.14998125234345708
1222.0, 1.8372703412073492
1223.0, 2.6996625421822276
1224.300048828125, 9.898762654668166
1224.9000244140625, 0.9373828271466067
1227.300048828125, 1.2373453318335208
1228.0999755859375, 0.974878140232471
1229.0999755859375, 1.6497937757780279
1230.300048828125, 11.361079865016874
1232.699951171875, 18.59767529058868
1233.699951171875, 17.99775028121485
1235.199951171875, 13.498312710911136
1236.699951171875, 1.5748031496062993
1237.4000244140625, 1.2373453318335208
1239.199951171875, 1.2373453318335208
1240.0999755859375, 0.44994375703037126
1242.199951171875, 22.64716910386202
1242.800048828125, 22.57217847769029
1244.5999755859375, 0.0
1246.5999755859375, 2.0622422197225347
1247.800048828125, 6.749156355455568
1248.699951171875, 0.44994375703037126
1250.300048828125, 16.87289088863892
1251.0, 6.93663292088489
1252.300048828125, 0.6749156355455569
1252.800048828125, 0.8248968878890139
1253.5999755859375, 2.9996250468691414
1254.5999755859375, 2.324709411323585
1255.9000244140625, 19.197600299962506
1258.699951171875, 1.1998500187476566
1259.5999755859375, 4.1244844394450695
1260.5, 2.2872140982377203
1260.9000244140625, 1.6497937757780279
1262.5999755859375, 17.360329958755155
1265.699951171875, 100.0
1266.5999755859375, 17.810273715785527
1267.0999755859375, 13.535808023997001
1267.9000244140625, 0.8248968878890139
1268.199951171875, 0.7874015748031497
1268.9000244140625, 0.26246719160104987
1269.5, 0.3749531308586427
1270.0999755859375, 0.5999250093738283
1271.0, 0.6749156355455569
1272.0999755859375, 2.924634420697413
1273.0, 2.1372328458942635
1273.5999755859375, 1.1623547056617924
1274.0999755859375, 0.33745781777277845
1276.199951171875, 8.061492313460818
1278.5999755859375, 11.586051743532058
1279.4000244140625, 1.8747656542932134
1280.0, 2.4371953505811774
1282.0, 19.49756280464942
1282.5999755859375, 50.0562429696288
1283.800048828125, 7.011623547056618
1285.300048828125, 27.22159730033746
1286.199951171875, 6.224221972253469
1287.0999755859375, 7.8365204349456326
1290.0999755859375, 5.999250093738283
1291.0, 3.59955005624297
1291.800048828125, 10.611173603299589
1292.699951171875, 0.29996250468691416
1293.300048828125, 1.6497937757780279
1294.5, 0.22497187851518563
1296.699951171875, 23.322084739407575
1297.0999755859375, 23.772028496437947
1297.800048828125, 4.5744281964754405
1298.199951171875, 5.286839145106862
1299.5, 29.84626921634796
1300.9000244140625, 3.2995875515560558
1301.5999755859375, 0.26246719160104987
1303.5999755859375, 18.035245594300715
1304.4000244140625, 15.335583052118487
1305.0, 0.7874015748031497
1306.5999755859375, 0.41244844394450697
1308.5, 12.335958005249344
1309.800048828125, 11.061117360329959
1310.9000244140625, 3.9745031871016128
1312.0999755859375, 0.8623922009748782
1313.0999755859375, 0.11248593925759282
1315.0, 6.636670416197975
1316.0999755859375, 2.212223472065992
1318.0999755859375, 12.410948631421073
1318.9000244140625, 41.50731158605175
1319.9000244140625, 3.6370453693288343
1320.5999755859375, 8.211473565804274
1321.9000244140625, 0.29996250468691416
1322.4000244140625, 0.29996250468691416
1323.0, 1.5373078365204351
1324.5, 14.098237720284965
1327.5, 2.0622422197225347
1329.199951171875, 9.373828271466067
1331.300048828125, 23.209598800149983
1333.800048828125, 58.155230596175485
1335.800048828125, 0.5249343832020997
1336.5999755859375, 1.687289088863892
1337.5, 0.8998875140607425
1338.0999755859375, 2.81214848143982
1340.5, 22.084739407574055
1341.5, 0.7874015748031497
1342.4000244140625, 4.9118860142482195
1343.300048828125, 0.7499062617172854
1344.800048828125, 11.961004874390701
1345.5999755859375, 12.335958005249344
1347.699951171875, 38.282714660667416
1348.699951171875, 1.3123359580052494
1350.800048828125, 3.937007874015748
1352.199951171875, 2.5496812898387704
1353.300048828125, 3.5245594300712413
1355.300048828125, 6.1492313460817405
1355.9000244140625, 0.5999250093738283
1357.0999755859375, 9.411323584551932
1359.300048828125, 13.310836145481815
1359.800048828125, 15.035620547431572
1361.0, 23.88451443569554
1362.9000244140625, 18.59767529058868
1365.300048828125, 10.348706411698538
1366.4000244140625, 3.1496062992125986
1367.4000244140625, 1.387326584176978
1368.4000244140625, 1.387326584176978
1370.0999755859375, 0.44994375703037126
1370.5999755859375, 0.6749156355455569
1371.4000244140625, 1.3498312710911138
1372.4000244140625, 0.6374203224596926
1373.0, 0.8998875140607425
1373.5999755859375, 1.4998125234345707
1374.5, 1.6122984626921635
1375.300048828125, 0.7874015748031497
1377.5, 44.16947881514811
1378.300048828125, 8.51143607049119
1379.0999755859375, 3.374578177727784
1380.5999755859375, 25.346831646044247
1381.0, 25.271841019872518
1383.9000244140625, 8.173978252718411
1385.199951171875, 6.41169853768279
1386.5999755859375, 0.11248593925759282
1387.5, 1.0123734533183353
1388.199951171875, 0.5999250093738283
1388.5999755859375, 1.5748031496062993
1389.699951171875, 1.6497937757780279
1391.5999755859375, 10.236220472440946
1392.800048828125, 0.8248968878890139
1394.0, 0.03749531308586427
1396.0, 1.9122609673790778
1398.5, 6.636670416197975
1400.199951171875, 29.171353580802403
1401.0, 9.786276715410574
1402.300048828125, 0.8248968878890139
1403.5999755859375, 2.5871766029246346
1405.199951171875, 2.1747281589801277
1406.5, 0.7124109486314211
1407.800048828125, 0.11248593925759282
1409.199951171875, 1.3498312710911138
1409.9000244140625, 3.899512560929884
1411.0, 2.099737532808399
1412.0, 1.0498687664041995
1413.800048828125, 16.94788151481065
1414.9000244140625, 0.974878140232471
1415.199951171875, 0.8998875140607425
1416.0, 1.9872515935508064
1416.4000244140625, 2.5496812898387704
1418.199951171875, 24.521934758155233
1419.0999755859375, 1.3123359580052494
1421.199951171875, 1.9872515935508064
1421.5, 1.949756280464942
1422.300048828125, 3.6745406824146984
1423.5, 2.3997000374953132
1424.5, 24.296962879640045
1425.0999755859375, 5.174353205849269
1426.0999755859375, 7.686539182602175
1427.5999755859375, 16.1604799400075
1428.0999755859375, 11.173603299587553
1428.800048828125, 1.124859392575928
1429.300048828125, 0.7124109486314211
1429.9000244140625, 1.3498312710911138
1431.699951171875, 18.97262842144732
1433.300048828125, 8.248968878890139
1434.300048828125, 1.0498687664041995
1436.5, 16.985376827896513
1438.199951171875, 0.3749531308586427
1439.199951171875, 7.9490063742032255
1439.9000244140625, 3.224596925384327
1440.5999755859375, 1.0123734533183353
1441.199951171875, 2.362204724409449
1441.800048828125, 1.6122984626921635
1442.800048828125, 2.4746906636670416
1446.800048828125, 20.28496437945257
1448.800048828125, 13.198350206224223
1449.9000244140625, 0.03749531308586427
##END NTUPLES

`;

export default lcmsJcamp;
